var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-via-webDav" }, [
    _c("div", [
      _c("span", {
        staticClass: "add-ftp-des",
        domProps: {
          innerHTML: _vm._s(_vm.$t("language.popup.addCloudPopup.addNasWebDes"))
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "viaWEB-body" }, [
      _c("div", { staticClass: "cloud-cont" }, [
        _c("div", { staticClass: "cloud-viaWeb-name" }, [
          _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.displayName")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputCloudNameValue,
              expression: "inputCloudNameValue"
            }
          ],
          staticClass: "cloud-cont-input",
          style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
          attrs: { type: "text" },
          domProps: { value: _vm.inputCloudNameValue },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.inputCloudNameValue = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cloud-cont" },
        [
          _c("font", { staticClass: "cloud-viaWeb-name" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.server")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.portNumber,
                expression: "portNumber"
              }
            ],
            staticClass: "ftp-cont-right-one",
            attrs: { type: "text" },
            domProps: { value: _vm.portNumber },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.portNumber = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.webDavserverHttp,
                expression: "webDavserverHttp"
              }
            ],
            staticClass: "ftp-cont-input",
            style: {
              width: this.$i18n.locale == "italian" ? "260Px" : "279Px"
            },
            attrs: { type: "text" },
            domProps: { value: _vm.webDavserverHttp },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.webDavserverHttp = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "question-mark",
          staticStyle: { float: "left", position: "absolute" },
          on: {
            mouseleave: function($event) {
              _vm.explanShow = false
            },
            mouseover: function($event) {
              _vm.explanShow = true
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "icon-util question viaWeb-icon-position" },
            [
              _c(
                "div",
                {
                  staticClass: "webdav-explanation explanation nas-web-positon"
                },
                [
                  _c("font", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("language.popup.addCloudPopup.webDavQuestion")
                      )
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cloud-cont" },
        [
          _c("font", { staticClass: "cloud-viaWeb-name" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.userName")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.username,
                expression: "username"
              }
            ],
            staticClass: "cloud-cont-input",
            style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
            attrs: { type: "text" },
            domProps: { value: _vm.username },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.username = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cloud-cont" },
        [
          _c("font", { staticClass: "cloud-viaWeb-name" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.passWord")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            staticClass: "cloud-cont-input",
            style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
            attrs: { type: "password" },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cloud-cont" },
        [
          _c("font", { staticClass: "cloud-viaWeb-name" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.path")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.path,
                expression: "path"
              }
            ],
            staticClass: "cloud-cont-input",
            style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
            attrs: { type: "text" },
            domProps: { value: _vm.path },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.path = $event.target.value
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-549b0128", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549b0128","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_add_cloud/tab_via_webDav.vue
// module id = null
// module chunks = 